import { useEffect, useRef } from "react";

const UnicornBackground = () => {
  const initialized = useRef(false);

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    const existingScript = document.querySelector(
      'script[src*="unicornStudio"]'
    );
    if (existingScript) {
      if ((window as any).UnicornStudio?.init) {
        (window as any).UnicornStudio.init();
      }
      return;
    }

    (window as any).UnicornStudio = { isInitialized: false };
    const script = document.createElement("script");
    script.src =
      "https://cdn.jsdelivr.net/gh/hiunicornstudio/unicornstudio.js@v2.0.5/dist/unicornStudio.umd.js";
    script.onload = () => {
      if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", () => {
          (window as any).UnicornStudio.init();
        });
      } else {
        (window as any).UnicornStudio.init();
      }
    };
    (document.head || document.body).appendChild(script);
  }, []);

  return (
    <div
      data-us-project="ijz2c5oTTMqf2geIMYTl"
      className="fixed inset-0 w-full h-full pointer-events-none"
      style={{ zIndex: -1 }}
    />
  );
};

export default UnicornBackground;
